const dashboard_layout = {
    dashboardItemName: String("Dashboard"),
    terrainsItemName: String("Terrains"),
    plotsItemName: String("Plots"),
    modulesItemName: String("Modules"),
    accountItemName: String("My profile"),
    userOverlayBoxTitle: String("Welcome {name}"),
    profile: String("My profile"),
    logOut: String("Sign off"),
    footerAboutUs: String("About us"),
    footerContactUs: String("Contact us"),
    graphicsItemName: String("Graphics"),
};

export default dashboard_layout;